/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { PerformanceGroupCreateRequest } from '../models/PerformanceGroupCreateRequest';
import type { PerformanceGroupResponse } from '../models/PerformanceGroupResponse';
import type { PerformanceGroupSortRequest } from '../models/PerformanceGroupSortRequest';
import type { PerformanceGroupUpdateRequest } from '../models/PerformanceGroupUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceGroupService {
    /**
     * Create Performance Group
     * 성과 그룹 생성
     *
     * 새로운 성과 그룹을 생성합니다.
     * @returns PerformanceGroupResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceGroup({
        requestBody,
    }: {
        requestBody: PerformanceGroupCreateRequest,
    }): CancelablePromise<PerformanceGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/group',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performance Groups
     * 성과 그룹 목록 조회 및 검색
     *
     * 성과 그룹을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 그룹명, 공식으로 검색
     * @returns PaginatedResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformanceGroups({
        workspaceId,
        businessId,
        q,
        page = 1,
        perPage = 100,
    }: {
        workspaceId?: string,
        businessId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/group',
            query: {
                'workspace_id': workspaceId,
                'business_id': businessId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance Group
     * 성과 그룹 조회
     *
     * ID로 특정 성과 그룹을 조회합니다.
     * @returns PerformanceGroupResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformanceGroup({
        groupId,
    }: {
        groupId: string,
    }): CancelablePromise<PerformanceGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Group
     * 성과 그룹 정보 수정
     *
     * 특정 성과 그룹의 정보를 수정합니다.
     * @returns PerformanceGroupResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceGroup({
        groupId,
        requestBody,
    }: {
        groupId: string,
        requestBody: PerformanceGroupUpdateRequest,
    }): CancelablePromise<PerformanceGroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance Group
     * 성과 그룹 삭제
     *
     * 특정 성과 그룹을 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformanceGroup({
        groupId,
    }: {
        groupId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/group/{group_id}',
            path: {
                'group_id': groupId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Group Sort
     * 성과 그룹 정렬 순서 변경
     *
     * 성과 그룹의 정렬 순서를 변경합니다.
     * prev_group_id: 이동할 위치의 이전 그룹 ID (맨 앞이면 None)
     * next_group_id: 이동할 위치의 다음 그룹 ID (맨 뒤면 None)
     * @returns PerformanceGroupResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceGroupSort({
        groupId,
        requestBody,
    }: {
        groupId: string,
        requestBody: PerformanceGroupSortRequest,
    }): CancelablePromise<PerformanceGroupResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/performance/group/{group_id}/sort',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
